import * as React from "react";
import { Box, BoxProps } from "@mui/material";

type CenterProps = BoxProps & { minHeight?: number | string };

export default function Center({
  children,
  minHeight = 240,
  sx,
  ...rest
}: CenterProps) {
  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        width: "100%",
        height: "100%",
        minHeight,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
